// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: false,
  appVersionAddon: '-staging',
  webappName: 'Straatbeeld Online Behandelaar (staging)',
  api_endpoint: 'https://api.sd-staging.nl/',
  pusher: {
    broadcaster: 'pusher',
    key: 'fd4c5bb275e8ae76f1b4',
    cluster: 'eu',
    forceTLS: true,
  },
  pusher_beams_client_id: '5fd35e8d-afd3-4182-a6ca-31bc24a10457',
  sentry: {
    dsn: 'https://b2cdd327256879a4c31c02b9cc279463@o4507735602298880.ingest.de.sentry.io/4508745347498064',
    environment: 'staging',
    version: version + '-staging',
  }
};
